import React, { useState } from "react";
import PropTypes from "prop-types";
import GenericCard from "../UI/GenericCard/GenericCard";
import dayjs from "dayjs";
import { Switch } from "antd";

const AverageHold = (props) => {
  const { backtestResults } = props;
  const [showMedian, setShowMedian] = useState(false);

  return (
    <GenericCard title={`${showMedian ? "Median" : "Average"} hold duration`}>
      <div className="flex justify-between items-center">
        <h3>
          {showMedian
            ? backtestResults.metrics.holdingDaysPercentiles?.total?.p50 || 0
            : backtestResults.metrics.averageDuration}{" "}
          bars
        </h3>
        <div className="flex items-center">
          <span className="min-w-[60px]">
            {showMedian ? "Median" : "Average"}
          </span>
          <Switch checked={showMedian} onChange={setShowMedian} size="small" />
        </div>
      </div>

      <div className="flex">
        <div className="pe-[30px]">
          <h5>On success</h5>
          <h3>
            {showMedian
              ? backtestResults.metrics.holdingDaysPercentiles?.winning?.p50 ||
                0
              : backtestResults.metrics.averageWinDuration || 0}{" "}
            bars
          </h3>
        </div>
        <div>
          <h5>On failure</h5>
          <h3>
            {showMedian
              ? backtestResults.metrics.holdingDaysPercentiles?.losing?.p50 || 0
              : backtestResults.metrics.averageLossDuration || 0}{" "}
            bars
          </h3>
        </div>
      </div>

      <h5>Trading range</h5>
      {backtestResults.transactions.length > 0 ? (
        <h3>
          {dayjs(
            backtestResults.transactions[
              backtestResults.transactions.length - 1
            ].openDate
          ).format("DD/MM/YY")}{" "}
          -{" "}
          {dayjs(backtestResults.transactions[0].closeDate).format("DD/MM/YY")}{" "}
        </h3>
      ) : (
        <h3>No trades</h3>
      )}
    </GenericCard>
  );
};

AverageHold.propTypes = { backtestResults: PropTypes.object };

export default AverageHold;
